import { captureScreen } from 'react-native-view-shot';

/**
 * Capture a screenshot of the current screen.
 * Native: returns a tmpfile URI.
 * Web: returns a data-uri (via bundled html2canvas).
 * Returns null if capture fails — feedback is still submittable without a screenshot.
 */
export async function captureScreenshot(): Promise<string | null> {
  try {
    const uri = await captureScreen({
      format: 'jpg',
      quality: 0.7,
    });
    return uri;
  } catch {
    return null;
  }
}
